// extracted by mini-css-extract-plugin
export default {"trackingText":"Tracking_trackingText__FdAN2","tracking":"Tracking_tracking__M3+UE","carrying":"Tracking_carrying__r4osz"};